module.exports = __webpack_public_path__ + "static/media/fr-tom.51ddc7db.jpg";